var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 453 453",
    style: {
      enableBackground: "new 0 0 453 453"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M265.4,32.5c-4.5-4.5-11.3-5.8-17.2-3.4s-9.7,8.2-9.7,14.6v84.3c-85.3,3.4-128,38.8-134.5,44.6 c-43,35.3-72.4,84.5-83.1,139.2c-5.3,26.4-6.3,53.5-2.8,80.2l0,0.1c0,0.2,0.1,0.5,0.1,0.7l3.4,19.3c1.1,6.5,6.2,11.6,12.7,12.8 c6.5,1.2,13-1.7,16.4-7.4l10.1-16.8c30.9-51.4,69.4-85.4,114.5-101.2c20.3-7.2,41.9-10.3,63.4-9.3v87.3c0,6.4,3.9,12.2,9.8,14.6 c5.9,2.4,12.7,1.1,17.2-3.5l166.9-167.7c6.2-6.2,6.1-16.2-0.1-22.3L265.4,32.5z M270.1,339.2V276c0-7.7-5.6-14.4-13.3-15.6 c-13.5-2.2-49.5-5.6-92.1,9.3c-45.4,15.9-84.7,47.2-117.1,93.3c-0.1-15.1,1.3-30.2,4.3-45.1c9.6-48.5,34-89.3,72.5-121.2 c0.3-0.3,0.7-0.6,1-0.9c1.1-1,41.2-37.2,128.9-36.6h0.1c8.7,0,15.8-7.1,15.8-15.8V81.7l128.8,128.1L270.1,339.2z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoShare);
export default __webpack_public_path__ + "static/media/picto-share.8450fe10.svg";
export { ForwardRef as ReactComponent };